import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Document } from 'UI/Icons';
import msal, { loginRequest, getToken } from 'lib/msal';
import getEnvironment from 'lib/env';

var AttachedDocuments = /*#__PURE__*/function (_Component) {
  _inherits(AttachedDocuments, _Component);

  var _super = _createSuper(AttachedDocuments);

  function AttachedDocuments(_props) {
    var _this;

    _classCallCheck(this, AttachedDocuments);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      _this.loadDocuments(nextProps);
    });

    _defineProperty(_assertThisInitialized(_this), "loadDocuments", function (props) {
      if (_this.token == null) {
        return false;
      }

      if (props.documents != null) {
        if (typeof props.documents === 'string') {
          var documentString = props.documents.split(';');
          var documents = [];
          documentString.forEach(function (document) {
            var documentObj = {
              name: document.indexOf("?") > 0 ? document.split("?")[0].substring(document.split("?")[0].lastIndexOf('/') + 1) : document.substring(document.lastIndexOf('/') + 1),
              url: document,
              remove: false
            };
            documents.push(documentObj);
          });

          _this.setState({
            documents: documents
          });
        } else {
          var _documents = [];
          props.documents.forEach(function (document) {
            var fileUrl = document.value;
            var documentObj = {
              name: document.name,
              url: fileUrl,
              remove: document.markedForDeletion != null ? document.markedForDeletion : false
            };

            _documents.push(documentObj);
          });

          _this.setState({
            documents: _documents
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "removeDocument", function (document) {
      var documents = _this.state.documents;
      var doc = documents.find(function (docItr) {
        return docItr.url == document.url;
      });

      if (doc.remove) {
        document.remove = false;
      } else {
        document.remove = true;
      }

      _this.setState({
        documents: documents
      });

      _this.props.removeInstruction(document.url, document.remove);
    });

    _defineProperty(_assertThisInitialized(_this), "renderDocuments", function () {
      if (_this.props.documents !== null) {
        var undo = _this.state.undo;
        var deleteTitle = _this.state["delete"];
        return _this.state.documents.map(function (document, i) {
          if (document.url !== '') {
            return /*#__PURE__*/React.createElement("div", {
              className: "document",
              key: "doc-".concat(i)
            }, /*#__PURE__*/React.createElement("a", {
              href: document.url,
              target: "_blank"
            }, /*#__PURE__*/React.createElement("div", {
              className: "icon"
            }, /*#__PURE__*/React.createElement(Document, null)), /*#__PURE__*/React.createElement("div", {
              className: "column-1"
            }, /*#__PURE__*/React.createElement("div", {
              className: "name"
            }, /*#__PURE__*/React.createElement("strong", null, document.name)))), _this.props.removeInstruction != null ? /*#__PURE__*/React.createElement("div", {
              className: "button button-secondary",
              onClick: function onClick() {
                _this.removeDocument(document);
              }
            }, document.remove ? undo : deleteTitle) : null, /*#__PURE__*/React.createElement("div", {
              style: {
                clear: 'both'
              }
            }));
          }
        });
      }
    });

    _this.state = {
      documents: [],
      undo: _this.props.translate('undo'),
      "delete": _this.props.translate('Delete')
    };
    _this.token = null;
    var request = loginRequest;
    request.scopes = [].concat(_toConsumableArray(getEnvironment().scopes), _toConsumableArray(request.scopes));
    getToken(request).then(function (response) {
      _this.token = response.accessToken;

      _this.loadDocuments(_this.props);
    });
    return _this;
  }

  _createClass(AttachedDocuments, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "attached-documents"
      }, this.renderDocuments());
    }
  }]);

  return AttachedDocuments;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps)(AttachedDocuments);